(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("consortium-expediente-expropiaciones", {
                parent: "entity",
                url: "/consortium-expediente-expropiaciones?page&sort&search",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_CONSORTIUM"],
                    pageTitle: "ConsortiumExpedienteExpropiacion",
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/consortium-expediente/consortium-expediente-expropiaciones/consortium-expediente-expropiaciones.html",
                        controller: "ConsortiumExpedienteExpropiacionController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                },
            })
            .state("consortium-expediente-expropiaciones.new", {
                parent: "consortium-expediente-expropiaciones",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN"],
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/consortium-expediente/consortium-expediente-expropiaciones/consortium-expediente-expropiaciones-new.html",
                        controller: "ConsortiumExpedienteExpropiacionNewController",
                        controllerAs: "vm",
                    },
                },
                ncyBreadcrumb: {
                    label: "Nuevo",
                    parent: "consortium-expediente-expropiaciones",
                },
                resolve: {
                    entity: function () {
                        return {
                            id: null,
                        };
                    },
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name ||
                                    "consortium-expediente-expropiaciones",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            })
            .state("consortium-expediente-expropiaciones.edit", {
                parent: "consortium-expediente-expropiaciones",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_CONSORTIUM"],
                    pageTitle: "ConsortiumExpedienteExpropiacion",
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/consortium-expediente/consortium-expediente-expropiaciones/consortium-expediente-expropiaciones-detail.html",
                        controller: "ConsortiumExpedienteExpropiacionDetailController",
                        controllerAs: "vm",
                    },
                },
                ncyBreadcrumb: {
                    label: "Lista",
                    parent: "consortium-expediente-expropiaciones",
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "ConsortiumExpedienteExpropiacion",
                        function (
                            $stateParams,
                            ConsortiumExpedienteExpropiacion
                        ) {
                            return ConsortiumExpedienteExpropiacion.get({
                                id: $stateParams.id,
                            }).$promise;
                        },
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name ||
                                    "consortium-expediente-expropiaciones",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            });
    }
})();
